export default {
    mensagem: {},
    protocolo:{},
    classificacoes:{},
    ufs: {},
    endereco:{},
    sas: {},
    grupoTratamentoUFClassificacao: {},
    anexos:{},
    campanha:{},
    navegacao:{},
    atendimento:{
            enviado:{}
        },
    tipoPessoa:{
        tiposVisiveis:{}
    },
    relatorioClassificacao:{},
    relatorioSituacao:{},
    relatorioTempoRespostaFaixa: {},
    relatorioIndicadorTempoRespostaFaixa: {},
    relatorioParametros:{},
    relatorioIndicadorNivelClassificacao: {},
    relatorioAssuntoCassificacaoEstrutura:{},
    relatorioTop5Assunto:{},
    relatorioQuantitativoIntervaloAno:{},
    relatorioHierarquiaAssunto: {},
    relatorioHierarquiaAssuntoPorNatureza:{},
    relatorioHierarquiaEstrutura: {},
    relatorioClassificacaoPorAssunto:{},
    relatorioTempoRespostaClassificacaoFaixa:{},
    relatorioGeral:{
        direcionarGrupoTratamento:null
    },

}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/initialState.js
 **/